import React from "react";
import { Sun, Utensils, Bus, Smile, Home, DoorOpen } from "lucide-react";

const STEPS = [
  {
    time: "10:00",
    title: "Arrival and welcome",
    text: "A friendly hello, a cuppa and a catch-up while we plan the day together.",
    icon: DoorOpen,
    photo: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hz4qbkr1_IMG-20260611-WA0003.jpg",
    alt: "Two people we support sharing a high five during a sensory game.",
  },
  {
    time: "10:30",
    title: "Morning activity",
    text: "Sport, crafts, music or life skills — everyone chooses what they enjoy.",
    icon: Sun,
    photo: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/uecqaya5_20260623_135433.jpg",
    alt: "Someone we support shaping clay in a craft session.",
  },
  {
    time: "12:30",
    title: "Lunch and social time",
    text: "Time to relax, chat and enjoy lunch with friends — sometimes one we've cooked ourselves!",
    icon: Utensils,
    photo: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/kq5fn77i_IMG-20260619-WA0004.jpg",
    alt: "A support worker helping someone we support during a cooking session.",
  },
  {
    time: "13:30",
    title: "Afternoon activity or trip out",
    text: "Days out, community visits, swimming or games — building confidence in the real world.",
    icon: Bus,
    photo: "https://customer-assets.emergentagent.com/job_spire-support-hub/artifacts/hjrnzf5p_IMG-20260619-WA0003.jpg",
    alt: "A group from Spire Inclusion enjoying a trip to the cinema together.",
  },
  {
    time: "15:00",
    title: "Wind down and reflect",
    text: "A calm end to the day — sharing highlights and looking forward to tomorrow.",
    icon: Smile,
    photo: null,
    alt: "",
  },
  {
    time: "15:30",
    title: "Home time",
    text: "Everyone heads home happy, with new stories to tell.",
    icon: Home,
    photo: null,
    alt: "",
  },
];

export const DayTimeline = () => (
  <ol className="relative mt-12 space-y-10 border-l-2 border-orange-200 pl-0 ml-4 sm:ml-6" data-testid="day-timeline">
    {STEPS.map((s, i) => (
      <li key={s.time} className="relative pl-10 sm:pl-14" data-testid={`day-timeline-step-${i}`}>
        <span className="absolute -left-[1.4rem] top-0 flex h-11 w-11 items-center justify-center rounded-full bg-orange-600 text-white ring-4 ring-orange-100">
          <s.icon className="h-5 w-5" aria-hidden="true" />
        </span>
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
          <div className="flex-1">
            <p className="font-heading text-sm font-bold uppercase tracking-wide text-orange-700">{s.time}</p>
            <h3 className="mt-1 font-heading text-2xl font-semibold text-stone-900">{s.title}</h3>
            <p className="mt-2 max-w-xl text-lg text-stone-700 leading-relaxed">{s.text}</p>
          </div>
          {s.photo && (
            <img
              src={s.photo}
              alt={s.alt}
              loading="lazy"
              className="h-40 w-full sm:w-56 rounded-2xl object-cover shadow-md shrink-0"
            />
          )}
        </div>
      </li>
    ))}
  </ol>
);
